import React from "react";
var Footer = function () {
    return (React.createElement("footer", { className: "flex-row w-full bg-gray-800 text-white py-6 text-center" },
        React.createElement("p", { className: "mb-2" }, "\u00A9 2026 Electric Era Technologies. All rights reserved."),
        React.createElement("p", null, "Powernode Platform\u2122")));
};
export default Footer;
